module.exports = __webpack_public_path__ + "static/media/why-img2.e69ecf23.png";